
define('text!presentation/shell/views/index.html',[],function () { return '<div />';});

